export {
	mainMenu,
	toolsMenu,
	utilitiesMenu,
	integrationsMenu,
	injectIntoPageIndication,
	injectIntoResponsive,
	injectIntoPrimaryAction,
} from './locations';

export { documentOptionsMenu } from './extensions/documents-save/locations';

export type { ActionProps, LinkProps, ToggleActionProps } from './types';

export { init } from './init';
